<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    floating
    persistent
    mobile-breakpoint="991"
    width="80"
    class="fill-height"
  >
    <v-layout column class="tw-h-full d-flex tw-relative tw-p-0">
      <div class="tw-w-full">
        <v-list-item class="">
          <v-img :src="logo" height="44" contain />
        </v-list-item>
        <div class="tw-text-center">
          <v-list-item
            v-for="(link, i) in navigationLinks"
            :key="i"
            :to="link.to"
            class="tw-mx-0 tw-px-0"
          >
            <div class="tw-w-full tw-items-center tw-content-center tw-px-0 tw-mx-0">
              <v-list-item-action class="tw-mx-0 tw-pl-2 tw-text-center tw-ml-5">
                <v-icon medium light class="tw-mx-0"> {{ link.icon }} </v-icon>
              </v-list-item-action>
            </div>
          </v-list-item>
        </div>
      </div>
      <div class="d-flex tw-absolute tw-bottom-0 tw-w-full tw-text-center">
        <v-list-item enabled class="v-list__tile--buy tw-m-0 tw-p-0" @click="logout">
          <v-list-item-title>
            <v-icon medium light class="tw-mx-0"> mdi-power </v-icon>
          </v-list-item-title>
        </v-list-item>
      </div>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from 'vuex';

export default {
  data: () => ({
    logo: '/img/kubiqalogo.png',
    links: [
      {
        to: '/dashboard',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard',
        mobile: true,
      },
      {
        to: '/inbox',
        icon: 'mdi-inbox',
        text: 'Inbox',
        mobile: true,
      },
      {
        to: '/opportunities',
        icon: 'mdi-shopping',
        text: 'Opportunities',
        mobile: true,
      },
      {
        to: '/listings',
        icon: 'mdi-home-city',
        text: 'Listings',
        mobile: false,
      },
      {
        to: '/contacts',
        icon: 'mdi-contacts',
        text: 'Contacts',
        mobile: true,
      },
      {
        to: '/website',
        icon: 'mdi-web',
        text: 'Website',
        mobile: false,
      },
      {
        to: '/settings/company',
        icon: 'mdi-cog',
        text: 'Settings',
        mobile: false,
      },
    ],
    responsive: false,
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    navigationLinks() {
      return this.$vuetify.breakpoint.mobile ? this.links.filter(link => link.mobile) : this.links;
    },
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    items() {
      return this.$t('Layout.View.items');
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    logout() {
      this.$store.dispatch('auth/logout');
      //this.$router.push('login')
    },
  },
};
</script>

<style lang="scss">
#app-drawer {
  .v-list {
    background-color: white;
  }
  .v-list__tile {
    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
      font-size: 11px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
